var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloodWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 9.13957L26.2812 11.0646C26.2812 11.0646 23.3479 14.3875 20.3917 18.6958C17.4354 23.0042 14.25 28.1604 14.25 33.1104C14.25 36.7571 15.6987 40.2545 18.2773 42.8331C20.8559 45.4117 24.3533 46.8604 28 46.8604C31.6467 46.8604 35.1441 45.4117 37.7227 42.8331C40.3013 40.2545 41.75 36.7571 41.75 33.1104C41.75 28.1604 38.5646 23.0042 35.6083 18.6958C33.7849 16.0472 31.8188 13.4997 29.7188 11.0646L28 9.13957ZM28 16.3125C29.0083 17.5042 29.925 18.4896 31.85 21.2854C34.6229 25.3187 37.1667 30.4521 37.1667 33.1104C37.1667 38.1979 33.0875 42.2771 28 42.2771C22.9125 42.2771 18.8333 38.1979 18.8333 33.1104C18.8333 30.4521 21.3771 25.3187 24.15 21.2854C26.075 18.4896 26.9917 17.5042 28 16.3125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodWhite);
export default __webpack_public_path__ + "static/media/bloodWhite.97f8a5db2c4586959630ca43bb3411c7.svg";
export { ForwardRef as ReactComponent };